// extracted by mini-css-extract-plugin
export default {"error":"Page-404_error__SwUre"};